import { useEffect, useState } from "react";
import PageTab from "./basePageComponents/tabs/PageTab";
import { AccountImage } from "./basePageComponents/images/AccountImage";
import './home.css';
import TaskCard from "./tasksPages/TaskCard";
import FamilySwitch from "./FamilySwicth";
import CONSTS from "./Constants";
import Loader from "./Loader";
import { NotificationContainer } from "react-notifications";
import isDemoEnabled from "./demo_mode/is_demo_enabled";
import ErrorPage from "./ErrorPage";
import LOAD_ERROR_TYPES from "./enums/LoadErrorTypes";
import DemoAccount from "./demo_mode/demo_account";
import { TranslationContextProvider } from "schummar-translate/react";
import t from './translations/translate.ts';
import { Link } from 'react-router-dom';
import {ifRightToLeft, ifLeftToRight} from './utils/ifLangDir.js';
import { useLocale } from './LocaleContext';
import { useCache } from './DataCache';
// Функция отправки POST запроса для перевода
async function sendTranslationRequest(sourceTexts, sourceLanguage = 'en', targetLanguage = 'he') {
    const url = 'https://translate_api.ludenlabs.com/lng_api/translate';

    const data = {
        source_texts: sourceTexts,
        source_language: sourceLanguage,
        target_language: targetLanguage
    };

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        });

        const result = await response.json();

        return {
            data: result,
            statusCode: response.status,
            ok: response.ok
        };

    } catch (error) {
        return {
            error: error.message,
            statusCode: 500
        };
    }
}

//qqq
async function translateObject(obj, targetLocale) {
    if (!obj || typeof obj !== 'object') return obj;

    // === КЭШ ===
    const CACHE_KEY = 'tamar_translate_cache_v1';
    let cache;
    try {
        const cacheData = localStorage.getItem(CACHE_KEY);
        cache = cacheData ? JSON.parse(cacheData) : { detections: {}, translations: {} };
    } catch (err) {
        console.error('Error loading cache:', err);
        cache = { detections: {}, translations: {} };
    }

    let cacheUpdated = false;

    // === 1. Собираем все тексты ===
    const textsToTranslate = [];
    const textMap = new Map(); // text -> [paths...]

    function collectTexts(current, path = []) {
        if (Array.isArray(current)) {
            current.forEach((v, i) => collectTexts(v, [...path, i]));
        } else if (current && typeof current === 'object') {
            for (const key in current) {
                if (!Object.prototype.hasOwnProperty.call(current, key)) continue;
                const val = current[key];
                if ((key === 'title' || key === 'description') && typeof val === 'string' && val.trim() !== '') {
                    textsToTranslate.push(val);
                    if (!textMap.has(val)) textMap.set(val, []);
                    textMap.get(val).push([...path, key]);
                } else {
                    collectTexts(val, [...path, key]);
                }
            }
        }
    }
    collectTexts(obj);
    if (textsToTranslate.length === 0) return obj;

    // === 2. Определяем языки ===
    for (const text of textsToTranslate) {
        if (typeof cache.detections[text] === 'undefined') {
            try {
                const detectRes = await fetch("https://translate_api.ludenlabs.com/detect", {
                    method: "POST",
                    body: JSON.stringify({ q: text }),
                    headers: { "Content-Type": "application/json" }
                });
                const json = await detectRes.json();
                const sourceLang = Array.isArray(json) ? json[0]?.language : json?.language;
                cache.detections[text] = sourceLang || null;
                cacheUpdated = true;
            } catch (err) {
                console.error("Detection error:", err);
                cache.detections[text] = null;
            }
        }
    }

    // === 3. Группируем тексты по исходному языку ===
    const langGroups = {};
    for (const text of textsToTranslate) {
        const lang = cache.detections[text] ?? 'und';
        if (!langGroups[lang]) langGroups[lang] = [];
        langGroups[lang].push(text);
    }

    // === 4. Переводим пакетами ===
    for (const [lang, texts] of Object.entries(langGroups)) {
        const normalizedSource = lang === "he" ? "iw" : lang;
        const normalizedTarget = targetLocale === "iw" ? "he" : targetLocale;
        if (normalizedSource === normalizedTarget) continue;

        const toTranslate = texts.filter(t => {
            const key = `${t}|||${normalizedTarget}`;
            return typeof cache.translations[key] === 'undefined';
        });
        if (toTranslate.length === 0) continue;

        console.group(`Batch translate ${normalizedSource} → ${normalizedTarget}`);
        console.log("Отправляем текстов:", toTranslate.length);

        try {
            const res = await sendTranslationRequest(toTranslate, normalizedSource, normalizedTarget);

            if (res.ok && res.data && Array.isArray(res.data.translation)) {
                // сервер всегда возвращает [["...","..."]]
                const translations = res.data.translation[0];

                if (Array.isArray(translations) && translations.length === toTranslate.length) {
                    for (let i = 0; i < toTranslate.length; i++) {
                        const key = `${toTranslate[i]}|||${normalizedTarget}`;
                        cache.translations[key] = translations[i];
                    }
                    cacheUpdated = true;
                    console.log("Переведено:", translations.length);
                } else {
                    console.error("⚠️ Некорректная длина ответа от сервера:", {
                        sent: toTranslate.length,
                        received: translations?.length ?? 0,
                        translations
                    });
                }
            } else {
                console.error("Ошибка запроса перевода:", res);
            }
        } catch (err) {
            console.error("Ошибка при вызове sendTranslationRequest:", err);
        }

        console.groupEnd();
    }

    // === 5. Применяем переводы ===
    const resultObj = (typeof structuredClone === 'function') ? structuredClone(obj) : JSON.parse(JSON.stringify(obj));
    for (const [text, paths] of textMap.entries()) {
        const cacheKey = `${text}|||${targetLocale}`;
        const translated = cache.translations[cacheKey] ?? text;
        for (const path of paths) {
            let ref = resultObj;
            for (let i = 0; i < path.length - 1; i++) {
                ref = ref[path[i]];
                if (ref == null) break;
            }
            if (ref != null) {
                ref[path[path.length - 1]] = translated;
            }
        }
    }

    // === 6. Сохраняем кэш ===
    if (cacheUpdated) {
        try {
            localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
        } catch (err) {
            console.error('Error saving cache:', err);
        }
    }

    return resultObj;
}

//qqq

function getQueryParams() {
    const params = {};
    const queryString = window.location.search.substring(1);
    const pairs = queryString.split("&");
    pairs.forEach(pair => {
        const [key, value] = pair.split("=");
        params[decodeURIComponent(key)] = decodeURIComponent(value || "");
    });
    return params;
}

export function convertAndGroupByDate(maintenanceRepairs, todayDate) {
    function compareDates(date1, date2) {
        date1.setHours(0, 0, 0, 0);
        date2.setHours(0, 0, 0, 0);
        if (date1 > date2) {
            return false;
        } else if (date1 < date2) {
            return false;
        } else {
            return true;
        }
    }
    function convertToDate(dateString, timeString) {
        return new Date(dateString + 'T' + timeString);
    }
    function convertToLocal(dateString, timeString) {
        const utcDate = convertToDate(dateString, timeString);
        return utcDate.toLocaleString('ru-RU');
    }
    
    const grouped = maintenanceRepairs.reduce((acc, item) => {
        const localStartAt = convertToLocal(item.date, item.start_at);
        const localEndAt = convertToLocal(item.date, item.end_at);
        const localDate = localStartAt.split(',')[0];
        if (!acc[localDate]) {
            acc[localDate] = { tasks: [], today: compareDates(todayDate, convertToDate(item.date, item.start_at)) };
        }
        acc[localDate].tasks.push({
            task_date: convertToDate(item.date, item.start_at),
            local_start_at: localStartAt,
            local_end_at: localEndAt,
            ...item
        });
        return acc;
    }, {});

    const todayNormalized = new Date(todayDate);
    todayNormalized.setHours(0, 0, 0, 0);

    const sortedKeys = Object.keys(grouped).sort((a, b) => {
        if (grouped[a].today) return -1;
        if (grouped[b].today) return 1;
        
        const dateA = grouped[a].tasks[0]?.task_date;
        const dateB = grouped[b].tasks[0]?.task_date;
        if (dateA && dateB) {
            return dateA.getTime() - dateB.getTime();
        }
        return 0;
    });

    const sorted = {};
    for (const key of sortedKeys) {
        sorted[key] = grouped[key];
    }
    return sorted;
}

function t__() {
    return {
        "id": -1,
        "type": "no_time",
        "title": "Lorem Ipsum",
        "description": null,
        "category": "emotional",
        "category_slug": null,
        "status": "initial",
        "creator":
        {
            "full_name": "QA Hleb",
            "formatted_phone_number": "+375 44 522-57-41"
        }
    }
}

const TaskTab = {
    AllTasks: t('tab_all'),
    Available: t('tab_available'),
    MyTasks: t('tab_my'),
    //FinihedTasks: t('completed_')
};

const TaskCounterKeys = {
    AllTasks: ({ all }) => all,
    Available: ({ initial }) => initial,
    MyTasks: ({ my }) => my
};

export default function Home() {
    const CurrentDate = new Date();
    const { locale } = useLocale();
    const { tab } = getQueryParams();
    const cache = useCache();

    useEffect(() => {
        if (!tab) {
            const url = new URL(window.location.href);
            url.searchParams.set('tab', 'AllTasks');
            window.history.replaceState(null, '', url.toString());
        }
    }, []);
    //
    if (!localStorage.getItem("login_familyToken") && !isDemoEnabled()) {
        return <ErrorPage errType={LOAD_ERROR_TYPES.AUTH_TOKEN_NOT_FOUND} />;
    }
    //
    const userToken = localStorage.getItem("login_userToken");
    const familyToken = localStorage.getItem("login_familyToken");
    const profileUrl = `${CONSTS.BASE_API_URL}/supporters/${userToken}`;
    const familyUrl = `${profileUrl}/families/${familyToken}`;
    const taskUrl = `${familyUrl}/tasks`;
    //
    const [isSwitchOpen, setSwitchOpen] = useState(false);
    const [selectedTab, setSelectedTab] = useState(TaskTab[tab] || TaskTab.AllTasks);
    const [profileData, setProfileData] = useState(null);
    const [familyData, setFamilyData] = useState(null);
    const [wasLoadStarted, setLoadStrted] = useState(false);
    const [wasError, setError] = useState(null);
    //
    const [tasksData, setTasksData] = useState({});
    const [rawTasks, setRawTasks] = useState(null);

    function filterAndGroup(fetchedTasksList, locale) {
        var taskFiltered = fetchedTasksList;
        if (selectedTab === TaskTab.MyTasks) {
            taskFiltered = {
                no_time: fetchedTasksList.no_time.filter((task) => task.assigned_on_me && task.status != "initial"),
                events: fetchedTasksList.events.filter((task) => task.assigned_on_me && task.status != "initial")
            };
        } else if (selectedTab === TaskTab.Available) {
            taskFiltered = {
                no_time: fetchedTasksList.no_time.filter((task) => task.status === "initial"),
                events: fetchedTasksList.events.filter((task) => task.status === "initial")
            };
        }
        const taskDataGrouped = convertAndGroupByDate(taskFiltered.events, CurrentDate);
        return {
            ["Any time"]: { tasks: taskFiltered.no_time, today: false },
            ...taskDataGrouped
        };
    }

    async function loadData(forceRefresh = false) {
        try {
            var fetchedTasksList = null;
            var j1 = null;
            var j2 = null;
            if (isDemoEnabled()) {
                const d = new DemoAccount();
                j2 = (d.family);
                j1 = (d.supporter);
                fetchedTasksList = ({
                    no_time: d.no_time,
                    events: d.events
                });
            } else {
                const cacheKey = `tasks_${userToken}_${familyToken}`;
                const cachedData = forceRefresh ? null : cache.get(cacheKey);

                if (cachedData) {
                    console.log("using cached data");
                    j1 = cachedData.profile;
                    j2 = cachedData.family;
                    fetchedTasksList = cachedData.tasks;
                } else {
                    console.log("requests started");
                    j1 = await (await fetch(profileUrl)).json();
                    j2 = await (await fetch(familyUrl)).json();

                    fetchedTasksList = (await (await fetch(taskUrl)).json());
                    console.log("requests finished");

                    cache.set(cacheKey, {
                        profile: j1,
                        family: j2,
                        tasks: fetchedTasksList
                    });
                }
            }

            setProfileData(j1);

            const allItems = [
                ...(fetchedTasksList.no_time || []),
                ...(fetchedTasksList.events || [])
            ];
            j2.tasks_counter = {
                "all": allItems.length,
                "initial": allItems.filter(i => i.status === "initial").length,
                "in_progress": allItems.filter(i => i.status === "in_progress").length,
                "completed": allItems.filter(i => i.status === "completed").length,
                "expired": allItems.filter(i => i.status === "expired").length,
                "my": allItems.filter(i => i.assigned_on_me && i.status !== "initial").length
            };
            setFamilyData(j2);

            const translated = await translateObject(fetchedTasksList, locale);
            setRawTasks(translated);
            setTasksData(filterAndGroup(translated));

        } catch (e) {
            console.log(e);
            setError(true);
        }
    }

    useEffect(() => {
        if (wasLoadStarted == false) {
            setLoadStrted(true);
            loadData();
        }
    }, [wasLoadStarted]);

    useEffect(() => {
        if (rawTasks) {
            setTasksData(filterAndGroup(rawTasks));
        }
    }, [selectedTab]);
    //
    if (wasError) {
        return <ErrorPage errType={LOAD_ERROR_TYPES.PAGE_LOAD_ERROR} />
    }
    //
    if (!wasLoadStarted || profileData == null || familyData == null || tasksData == null) {
        return <Loader />
    }
    console.log(profileData);
    console.log(familyData);
    //
    console.log("25 10 2025 -- локализацию дебажить тут -- ДЕБАЖИТЬ ТУТ!!!");



    /*var taskFiltered = taskAllData;
    //
    if (selectedTab === TaskTab.MyTasks) {
        // filter: task.assigned_on_me === true
        taskFiltered = {
            no_time: taskAllData.no_time.filter((task) => task.assigned_on_me && task.status != "initial"),
            events: taskAllData.events.filter((task) => task.assigned_on_me && task.status != "initial")
        }
    } else if (selectedTab === TaskTab.Available) {
        taskFiltered = {
            no_time: taskAllData.no_time.filter((task) => task.status === "initial"),
            events: taskAllData.events.filter((task) => task.status === "initial")
        }
    }
    console.log("to translate", taskFiltered);
    //taskFiltered = await translateObject(taskFiltered, localStorage.getItem("locale") || "en");
    //
    const taskDataGrouped = convertAndGroupByDate(taskFiltered.events, CurrentDate);
    //
    const tasksData = {
        ["Any time"]: { tasks: taskFiltered.no_time, today: false },
        ...taskDataGrouped
    };
    //
    console.log(tasksData);*/


    //
    return <TranslationContextProvider locale={locale}><div className="HomePage"
        style={{ direction: ifRightToLeft() ? 'rtl' : 'ltr' }}
    >
        <div>
            <div>
                <div className="_black_20_bold no_select"
                    onClick={() => setSwitchOpen(true)}
                    style={{
                        display: 'inline-block',
                        marginTop: 20, marginLeft: 20, marginRight: 20,
                        width: 'calc(100% - 100px)'
                    }}>
                    <span>{familyData.title}</span>
                    &nbsp;
                    <img src={AccountImage.DropDown} alt="^" />
                </div>
                <div className="no_select" style={{ display: 'inline-block', width: 24, height: 24 }}>
                    <Link to="/me"><img src={AccountImage.Profile} alt="avatar" /></Link>
                </div>
            </div>
            <div style={{
                height: 1.5, marginTop: 16, marginBottom: 16,
                marginLeft: 20, marginRight: 20,
                width: 'calc(100% - 40px)', backgroundColor: '#F0F0F0'
            }} />
            <nav className="TabList no_select">
                <div style={{ width: 460 }}>
                    {Object.keys(TaskTab).map((tab, key) =>
                        <PageTab tabName={tab} key={key}
                            onSelected={(tabName) => setSelectedTab(TaskTab[tabName])}
                            label_txt={
                                <span>
                                    <span>{TaskTab[tab]}</span>
                                    &nbsp; (<span>{TaskCounterKeys[tab](familyData.tasks_counter)}</span>)
                                </span>
                            }
                            is_selected={TaskTab[tab] == selectedTab} />)}
                </div>
            </nav>
            <div className="TaskList base_background">
                {Object.keys(tasksData).map((day, key) => <div key={key}>
                    <div>
                        <span className="_black_bold">{day === 'Any time' ? t('any_time') : day}</span> &nbsp;
                        {tasksData[day].today ? <span className="_grey_16">Today</span> : <></>}
                    </div>
                    <br />
                    {tasksData[day].tasks.map((task, k) => <div key={k}>
                        <TaskCard task={task}
                            updateTasks={() => {
                                loadData();
                            }}
                            link={familyUrl + (task.type === "no_time" ? '/tasks/' : '/events/') + (task.type === "no_time" ? task.id : task.id)}
                        />
                    </div>)}
                    <br />
                </div>)}
            </div>
        </div>
        <FamilySwitch isOpen={isSwitchOpen} close={() => setSwitchOpen(false)} />
        <NotificationContainer />
    </div>
    </TranslationContextProvider>
};